import type { SVGProps } from "react";

export default function PenNewSquareIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.3323 8.75032V10.0003C18.3323 13.9287 18.3323 15.8929 17.1119 17.1132C15.8916 18.3337 13.9273 18.3337 9.99897 18.3337C6.0706 18.3337 4.10642 18.3337 2.88603 17.1132C1.66564 15.8929 1.66564 13.9287 1.66564 10.0003C1.66564 6.07195 1.66564 4.10776 2.88603 2.88738C4.10642 1.66699 6.0706 1.66699 9.99897 1.66699H11.249"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M7.0095 11.5837L7.49156 10.1375C7.64212 9.68574 7.71741 9.45991 7.81868 9.24741C7.93814 8.99674 8.08456 8.75982 8.25534 8.54091C8.40015 8.35524 8.56848 8.18694 8.90515 7.85027L13.8758 2.87954L14.4166 2.33886C15.3124 1.44303 16.7648 1.44303 17.6606 2.33886C18.5564 3.23469 18.5564 4.68712 17.6606 5.58294L17.1199 6.12362M13.8758 2.87954C13.8758 2.87954 13.9434 4.02848 14.9572 5.04226C15.971 6.05603 17.1199 6.12362 17.1199 6.12362M7.0095 11.5837L6.69757 12.5194C6.62348 12.7417 6.68133 12.9867 6.84702 13.1525C7.0127 13.3182 7.25777 13.376 7.48006 13.3019L8.41582 12.99L9.86198 12.5079C10.3137 12.3573 10.5396 12.2821 10.7521 12.1808C11.0027 12.0613 11.2396 11.9149 11.4586 11.7442C11.6442 11.5993 11.8126 11.431 12.1492 11.0943L17.1199 6.12362M7.0095 11.5837L8.41582 12.99"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
    </svg>
  );
}
